export enum ICON_CONSTANTS {
  NON_RETURNABLE_BLACK_NEW = 'NON_RETURNABLE_BLACK_NEW',
  NON_RETURNABLE_BLACK = 'NON_RETURNABLE_BLACK',
}

export const ICON_CONSTANTS_MAP = {
  [ICON_CONSTANTS.NON_RETURNABLE_BLACK_NEW]:
    'https://images.quince.com/3E3SxLDx3RwHCjQUxCn3Ip/815ab061c73c49c8bc87d0a949e163ef/nonReturnableBlackNew.inline.svg',
  [ICON_CONSTANTS.NON_RETURNABLE_BLACK]:
    'https://images.quince.com/RsgvVf4vhnazdnB6JiAi0/c1af2f8ee61783ab2dbb66fa9b621b39/nonReturnableBlack.inline.svg',
}
